import { useAssetLinks } from '../../hooks/useAssetLinks';
import { useValuationsStore } from '../../store/valuationsStore';
import { EntityLink } from '../EntityLink';

const AssetLinks = () => {
  const selectedAsset = useValuationsStore.use.selectedAssetDetails();
  const links = useAssetLinks(selectedAsset);

  return <EntityLink link={links.country} />;
};

export { AssetLinks };
